/* eslint-disable react/no-array-index-key */
import { ROUTES } from '@const/routes'
import React from 'react'
import { Switch, Route } from 'react-router'

import './Main.css'

import { MainToolbar } from './partials'

const PageNotFoundLayout = React.lazy(() => import('./404'))

type Props = {
  //
}

const Main: React.FC<Props> = () => (
  <>
    <MainToolbar />
    <main role="main" className="container-fluid">
      <React.Suspense fallback={<span>読み込み中...</span>}>
        <Route>
          <Switch>
            {ROUTES.map((route, index) => <Route key={index} {...route} />)}
            <Route component={PageNotFoundLayout} />
          </Switch>
        </Route>
      </React.Suspense>
    </main>
  </>
)

export default Main
